import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";

export const LoadingPage: React.FC = () => {
  return (
    <div
      className="absolute top-0 bottom-0 z-50 w-screen h-screen flex items-center justify-center bg-white bg-opacity-50">
      <FontAwesomeIcon
        icon={faSpinner}
        size="4x"
        className="animate-spin text-gray-500"
      />
    </div>
  )
}